import {
  Component, EventEmitter, Input, OnChanges, SimpleChanges, Output, HostListener,
  ElementRef, ViewChild, AfterViewInit, AfterContentChecked, OnDestroy, ViewEncapsulation
} from '@angular/core';
import { AppState } from '../../app.service';

declare var Velocity: any;
declare var dataLayer: any;

@Component({
    selector: 'pq-infinite-scroll-list',
    templateUrl: './infinite.scroll.list.component.html',
    styleUrls: ['./_infinite.scroll.list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InfiniteScrollListComponent implements OnChanges, AfterViewInit, AfterContentChecked, OnDestroy {
  @Input() public items: Object[] = [];
  @Input() public loading: boolean = false;
  @Input() public page: number = 0;
  @Input() public listStyle: string = 'images';
  @Input() public eof: boolean = false;
  @Input() public goToSection: boolean = false;
  @Input() public gaTileClickEvent: string = '';
  @Input() public gaTileClickOrigin: string = '';
  @Input() public isNonFictionBooks: boolean = false;
  @Input() public alphaDisplay: boolean = false;
  @Input() public linkParams: object = {};

  @Output() public windowEvent: EventEmitter<number> = new EventEmitter();

  @ViewChild('content', { read: ElementRef, static: false }) public contentContainer: ElementRef;

  public profile: string = this._appState.get('current_profile');
  public path: string = this.profile ? '/' + this.profile + '/document/' : '/document/';
  public enableInfiniteLoading: boolean = true;
  public isLoading: boolean = false;
  public theItems: Object[] = [];
  public defaultStyle: string = 'grid';

  private _limit: number = 20;
  private _goToSection: boolean = false;
  private _totalItemsChanged: number = 0;

  constructor (
    private _appState: AppState
  ) {
    this.theItems = [];
    this.isLoading = false;
    this.page = 0;
  }

  @HostListener('window:scroll', ['$event']) public onWindowScroll (_event: Event): void {
    const percentageShown = this._percentageVisible();
    if (percentageShown >= this._limit && this.isLoading === false && this.enableInfiniteLoading) {
      this.windowEvent.emit(this.page + 1);
    }
  }

  @HostListener('window:resize', ['$event']) public onWindowResize (_event: Event): void {
    const percentageShown = this._percentageVisible();
    const ele = this.contentContainer.nativeElement;
    const eleHeight = ele.offsetHeight || 0;
    const windowHeight = window.innerHeight;

    if (((percentageShown >= this._limit) || (windowHeight > eleHeight)) && this.isLoading === false && this.enableInfiniteLoading) {
      this.windowEvent.emit(this.page + 1);
    }

  }

  public ngOnChanges (changes: SimpleChanges): void {
    const totalItems = this.theItems.length;
    this._totalItemsChanged = (changes.items && changes.items.currentValue) ? changes.items.currentValue.length : 0;
    // condition#1 Initially totalItems=0 totalChangedItems=20 totalItems < totalChangedItems
    // condition#1.1 after scrolling down totalItems=20 totalChangedItems=40 totalItems < totalChangedItems
    // condition#2 end of bottom totalItems=74 totalChangedItems=74 totalItems == totalChangedItems
    // condition#3 After reaching end of bottom in sort by trending and after changing sort by to Last Updated totalItems=74 totalChangedItems=20 totalChangedItems < totalItems
    if (changes.items && (totalItems <= this._totalItemsChanged || this._totalItemsChanged < totalItems)) {
      if (totalItems && totalItems > 0 && this._totalItemsChanged > 0 && this._totalItemsChanged > totalItems) {
        let numOfImagesAddedInScroll = this._totalItemsChanged - totalItems;
        if (Array.isArray(dataLayer)) {
          dataLayer.push({
            'event': 'BrowseEvent',
            'action': 'Scroll',
            'label': numOfImagesAddedInScroll,
            'clickOrigin': this.gaTileClickOrigin
          });
        }
      }
      this.theItems = changes.items.currentValue;
    }

    this.isLoading = changes.loading ? changes.loading.currentValue :  false;

  }

  public ngAfterViewInit (): void {
    // update private variable from input from parent component on component initialization
    this._goToSection = this.goToSection;
    // reset total items changed to be zero on component initialization
    this._totalItemsChanged = 0;
    Velocity(document.getElementsByTagName('body')[0], 'scroll', { offset: 0, mobileHA: false });
  }

  public ngAfterContentChecked (): void {
    let scrollY = parseInt(localStorage.getItem('scrollY'));
    if (isNaN(scrollY) === false) {
      this._doScroll(scrollY);
    }
  }

  public ngOnDestroy (): void {
    this.theItems = [];
    if (window.pageYOffset) {
      localStorage.setItem('scrollY', window.pageYOffset.toString());
    }
  }

  public pushImageClickToGA(title: String, item: Object) {
    if (this.theItems && this.gaTileClickEvent && this.gaTileClickOrigin) {
      let imgPosition = this.theItems.indexOf(item);
      if (dataLayer && Array.isArray(dataLayer)) {
        dataLayer.push({
          'event': this.gaTileClickEvent,
          'label': title,
          'position': imgPosition,
          'clickOrigin': this.gaTileClickOrigin
        });
      }
    }
  }

  public requestLoadMoreItems () {
    this.windowEvent.emit(this.page + 1);
  }

  public trackItem (index, topic): string {
    return topic ? topic.id : undefined;
  }

  private _doScroll (offset: number): void {
    // added delay in order to prevent conflict with global(app.component) function that
    // moves view to top of page when navigating within the app
    window.setTimeout(() => {
      let urlData = location.pathname.toString().split("?")[0].split('/');
      let page = urlData[urlData.length - 1];
      if (page !== '1') {
        Velocity(document.getElementsByTagName('body')[0], 'scroll', { offset: offset, mobileHA: false });
        this._goToSection = false;
      }
    }, 500);

    // needs to be removed outside of the delay in order to allow for the user to be able to regain control of scrolling
    localStorage.removeItem('scrollY');
  }

  private _percentageVisible (): number {
    const ele = this.contentContainer.nativeElement;
    const windowHeight = window.innerHeight;
    const scrollTop = window.pageYOffset;
    const eleTop = ele.offsetTop || 0;
    const eleHeight = ele.offsetHeight || 0;
    const pos = ele.getBoundingClientRect();
    let percentage = 0;

    if (eleTop > (scrollTop + windowHeight)) {
      percentage = 0;
    } else if ((pos.top >= 0) && (pos.bottom <= windowHeight)) {
      percentage = 100;
    } else {
      let distance = (scrollTop + windowHeight) - eleTop;
      percentage = distance / ((windowHeight + eleHeight) / 100);
      percentage = Math.round(percentage);
    }

    return percentage;
  }
}
